import React, { useMemo, forwardRef } from 'react';
import PropTypes from 'prop-types';

// TODO use CSS modules for button styles?
const Button = forwardRef(({
  children,
  className,
  primary,
  reset,
  secondary,
  ...props
}, ref) => {
  const classList = useMemo(() => {
    const styles = ['btn'];

    if (reset) {
      return ['btn-reset', className];
    } else if (primary) {
      styles.push('btn-primary');
    } else if (secondary) {
      styles.push('btn-secondary');
    }

    styles.push(className);

    return styles;
  }, [
    className,
    primary,
    reset,
    secondary,
  ]);

  return (
    <button ref={ref} {...props} className={classList.join(' ').trim()}>
      {children}
    </button>
  );
});

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  primary: PropTypes.bool,
  reset: PropTypes.bool,
  secondary: PropTypes.bool,
  type: PropTypes.string,
};

Button.defaultProps = {
  className: '',
  primary: false,
  reset: false,
  secondary: false,
  type: 'button',
};

export default Button;
